import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Widget, WidgetWrapper, WidgetHeader, WidgetHeaderContent, WidgetTitle, WidgetSubtitle, WidgetText, WidgetCount, WidgetBody } from '@/components/custom/widget/widget';
import { WidgetInstructionWrapper, WidgetInstruction, WidgetInstructionHeader, WidgetInstructionNumber, WidgetInstructionInfo, WidgetInstructionTitle, WidgetInstructionDescription } from '@/components/custom/widget/widget-instruction';
import { DashboardSection as Section, DashboardSectionTitle } from '@/components/custom/dashboard/dashboard-section';
import {
  DashboardShortcutCardWrapper,
  DashboardShortcutCard,
  DashboardShortcutCardImgWrapper,
  DashboardShortcutCardLiveDot,
  DashboardShortcutCardImg,
  DashboardShortcutCardContent,
  DashboardShortcutCardHeader,
  DashboardShortcutCardHat,
  DashboardShortcutCardTitle,
  DashboardShortcutCardText
} from '@/components/custom/dashboard/dashboard-shortcut-card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export function DashboardSection() {
  return (
    <ShowcaseSection
      id="dashboard"
      title="Dashboard"
      description="Widgets, sections e shortcut cards — building blocks do dashboard"
    >
      <ShowcaseItem
        label="Widget"
        description="Container base para qualquer card de dashboard (rounded-lg + bg-white + shadow-dropshadow + p-6)"
      >
        <Widget>
          <WidgetHeader>
            <WidgetHeaderContent>
              <WidgetTitle>Atividade recente</WidgetTitle>
              <WidgetCount>
                42 <span>itens</span>
              </WidgetCount>
            </WidgetHeaderContent>
            <WidgetSubtitle>Ultimos 30 dias</WidgetSubtitle>
          </WidgetHeader>
          <WidgetBody>
            <p className="m-0 text-sm text-neutral-dark">Conteudo do widget vai aqui. Pode conter graficos, listas, KPIs ou qualquer outro elemento.</p>
          </WidgetBody>
        </Widget>
      </ShowcaseItem>

      <ShowcaseItem
        label="WidgetWrapper — variante col"
        description="Layout de grupo de widgets com colunas auto-adjust"
      >
        <WidgetWrapper variant="col">
          <Widget>
            <WidgetHeader>
              <WidgetTitle>Widget A</WidgetTitle>
            </WidgetHeader>
            <WidgetBody>
              <WidgetText>Coluna 1</WidgetText>
            </WidgetBody>
          </Widget>
          <Widget>
            <WidgetHeader>
              <WidgetTitle>Widget B</WidgetTitle>
            </WidgetHeader>
            <WidgetBody>
              <WidgetText>Coluna 2</WidgetText>
            </WidgetBody>
          </Widget>
          <Widget>
            <WidgetHeader>
              <WidgetTitle>Widget C</WidgetTitle>
            </WidgetHeader>
            <WidgetBody>
              <WidgetText>Coluna 3</WidgetText>
            </WidgetBody>
          </Widget>
        </WidgetWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="WidgetInstruction"
        description="Passos numerados para onboarding/tutorial"
      >
        <WidgetInstructionWrapper>
          <WidgetInstruction>
            <WidgetInstructionHeader>
              <WidgetInstructionNumber>1</WidgetInstructionNumber>
              <WidgetInstructionInfo>
                <WidgetInstructionTitle>Crie sua turma</WidgetInstructionTitle>
                <WidgetInstructionDescription>Adicione alunos e professores a sua turma para comecar.</WidgetInstructionDescription>
              </WidgetInstructionInfo>
            </WidgetInstructionHeader>
          </WidgetInstruction>
          <WidgetInstruction>
            <WidgetInstructionHeader>
              <WidgetInstructionNumber>2</WidgetInstructionNumber>
              <WidgetInstructionInfo>
                <WidgetInstructionTitle>Configure o curso</WidgetInstructionTitle>
                <WidgetInstructionDescription>Defina modulos, aulas e materiais didaticos.</WidgetInstructionDescription>
              </WidgetInstructionInfo>
            </WidgetInstructionHeader>
          </WidgetInstruction>
          <WidgetInstruction>
            <WidgetInstructionHeader>
              <WidgetInstructionNumber>3</WidgetInstructionNumber>
              <WidgetInstructionInfo>
                <WidgetInstructionTitle>Acompanhe o progresso</WidgetInstructionTitle>
                <WidgetInstructionDescription>Veja relatorios em tempo real do desempenho dos alunos.</WidgetInstructionDescription>
              </WidgetInstructionInfo>
            </WidgetInstructionHeader>
          </WidgetInstruction>
        </WidgetInstructionWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="DashboardSection (custom wrapper)"
        description="Wrapper para agrupar conteudo de uma secao do dashboard com titulo"
      >
        <Section>
          <DashboardSectionTitle>Acompanhe seu progresso</DashboardSectionTitle>
          <p className="m-0 text-sm text-neutral-dark">Conteudo da secao vai aqui — pode conter widgets, cards, ou qualquer composicao.</p>
        </Section>
      </ShowcaseItem>

      <ShowcaseItem
        label="DashboardShortcutCard"
        description="Cartao de atalho para aulas/conteudos — com indicador 'live' animado"
      >
        <DashboardShortcutCardWrapper>
          <DashboardShortcutCard>
            <DashboardShortcutCardContent>
              <DashboardShortcutCardHeader>
                <DashboardShortcutCardHat>AO VIVO AGORA</DashboardShortcutCardHat>
                <DashboardShortcutCardTitle>Aula de Matematica</DashboardShortcutCardTitle>
              </DashboardShortcutCardHeader>
              <DashboardShortcutCardText>Prof. Carlos · 19:00</DashboardShortcutCardText>
            </DashboardShortcutCardContent>
            <DashboardShortcutCardImgWrapper>
              <DashboardShortcutCardLiveDot />
              <DashboardShortcutCardImg
                src=""
                alt=""
              />
            </DashboardShortcutCardImgWrapper>
          </DashboardShortcutCard>

          <DashboardShortcutCard>
            <DashboardShortcutCardContent>
              <DashboardShortcutCardHeader>
                <DashboardShortcutCardHat>HOJE</DashboardShortcutCardHat>
                <DashboardShortcutCardTitle>Quiz de Algebra</DashboardShortcutCardTitle>
              </DashboardShortcutCardHeader>
              <DashboardShortcutCardText>10 questoes · 15 min</DashboardShortcutCardText>
            </DashboardShortcutCardContent>
            <DashboardShortcutCardImgWrapper>
              <DashboardShortcutCardImg
                src=""
                alt=""
              />
            </DashboardShortcutCardImgWrapper>
          </DashboardShortcutCard>

          <DashboardShortcutCard>
            <DashboardShortcutCardContent>
              <DashboardShortcutCardHeader>
                <DashboardShortcutCardHat>AMANHA</DashboardShortcutCardHat>
                <DashboardShortcutCardTitle>Mentoria Individual</DashboardShortcutCardTitle>
              </DashboardShortcutCardHeader>
              <DashboardShortcutCardText>Profa. Ana · 14:00</DashboardShortcutCardText>
            </DashboardShortcutCardContent>
            <DashboardShortcutCardImgWrapper>
              <DashboardShortcutCardImg
                src=""
                alt=""
              />
            </DashboardShortcutCardImgWrapper>
          </DashboardShortcutCard>
        </DashboardShortcutCardWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="Composicao real — Widget com KPIs e botao"
        description="Padrao tipico de dashboard"
      >
        <Widget>
          <WidgetHeader>
            <WidgetHeaderContent>
              <WidgetTitle>Engajamento da turma</WidgetTitle>
              <Badge variant="success">+12%</Badge>
            </WidgetHeaderContent>
            <WidgetSubtitle>Comparado ao mes anterior</WidgetSubtitle>
          </WidgetHeader>
          <WidgetBody>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <div className="text-2xl font-extrabold text-primary">87%</div>
                <div className="text-xs text-neutral">Frequencia</div>
              </div>
              <div>
                <div className="text-2xl font-extrabold text-primary">42</div>
                <div className="text-xs text-neutral">Alunos ativos</div>
              </div>
              <div>
                <div className="text-2xl font-extrabold text-primary">9.1</div>
                <div className="text-xs text-neutral">Nota media</div>
              </div>
            </div>
            <div className="mt-4">
              <Button
                variant="outline"
                size="sm"
              >
                Ver detalhes
              </Button>
            </div>
          </WidgetBody>
        </Widget>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
